var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 42V6H54V42H6ZM5.25 0C2.35051 0 0 2.3505 0 5.25V42.75C0 45.6495 2.35051 48 5.25 48H54.75C57.6495 48 60 45.6495 60 42.75V5.25C60 2.3505 57.6495 0 54.75 0H5.25ZM30 18L28 18C27.4477 18 27 18.4477 27 19V20C27 20.5522 27.4477 21 28 21H31.5C35.6421 21 39 24.3578 39 28.5C39 32.1284 36.4234 35.1551 33 35.85V36C33 37.6569 31.6569 39 30 39C28.3431 39 27 37.6569 27 36L25.5 36C23.8431 36 22.5 34.6569 22.5 33C22.5 31.3431 23.8431 30 25.5 30H29.9952C29.9968 30 29.9984 30 30 30C30.0016 30 30.0032 30 30.0048 30H31.5C32.3284 30 33 29.3284 33 28.5C33 27.6715 32.3284 26.9999 31.5 26.9999H28C24.134 26.9999 21 23.8659 21 20V19C21 15.4735 23.6077 12.5561 27 12.0709V12C27 10.3431 28.3431 9 30 9C31.6569 9 33 10.3431 33 12L34.5 12C36.1569 12 37.5 13.3431 37.5 15C37.5 16.6569 36.1569 18 34.5 18L30 18Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/Claims.4f2f5e57.svg";
export { ForwardRef as ReactComponent };